module.exports = __webpack_public_path__ + "img/sicher-einkaufen-icon-data.3ccc48b1.svg";